// import queryString from 'query-string';

const getBasePath = () => {
  const { origin, pathname } = window.location;
  const basePath = pathname.split('/').slice(0, 4).join('/');
  return `${origin}${basePath}`;
};

const stringifyParams = (params) => {
  return Object.keys(params)
    .map((key) => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(params[key]);
      return `${encodedKey}=${encodedValue}`;
    })
    .join('&');
};

export const getReferralCenterUrl = (
  params: Record<string, string | number>
) => {
  const basePath = getBasePath();
  let search = '';

  try {
    search = stringifyParams(params);

  } catch (error) {
    console.warn('stringifyParams error:', error);
  }

  return `${basePath}/spotx/referral-records-rules${
    search ? `?${search}` : ''
  }`;
};
